import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CreditCheckLightRequest, CreditCheckResponse, CreditCheckStatusLabel } from '../../../models/credit-check';
import { AppState } from '../../../../state/app.state';
import { Store } from '@ngrx/store';
import { configurationFeatureSelector } from '../../../../state/app.selectors';
import { Subscription } from 'rxjs';
import { SupplierConfiguration } from '../../../../configuration/models/supplier-configuration';
import { SetCreditCheckErrorMessage, SetCreditCheckStatus } from '../../../../quoting/state/actions/quoting-module.actions';
import { getStatusLabel } from '../helpers/creditCheckHelper';
import { CreditCheckInput } from '../model/creditCheckInput';
import { CreditCheckService } from '../../../services/credit-check.service';

@Component({
  selector: 'app-credit-check-light-diag',
  templateUrl: './credit-check-light-diag.component.html',
  styleUrls: ['./credit-check-light-diag.component.scss']
})
export class CreditCheckLightDiagComponent implements OnInit, OnDestroy {
  public frmCreditCheckDetails: FormGroup;
  public isCreditCheckInProgress: boolean;
  private supplierConfig: SupplierConfiguration;
  public creditCheckResponse: CreditCheckResponse;

  private config$: Subscription;

  constructor(
    protected dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: CreditCheckInput,
    public dialogRef: MatDialogRef<CreditCheckLightDiagComponent>,
    private readonly store: Store<AppState>,
    private creditCheckService: CreditCheckService,
  ) { }

  ngOnDestroy(): void {
    this.config$.unsubscribe();
  }

  ngOnInit(): void {
    this.config$ = this.store.select(configurationFeatureSelector).subscribe((config) => {
      this.supplierConfig = config.config.supplierConfiguration;
    });

    this.initializeForm();
  }

  performCreditCheck() {
    this.isCreditCheckInProgress = true;

    const request: CreditCheckLightRequest = {
      dunsNumber: this.data.duns,
      businessName: this.data.organisationName,
      creditLimit: (this.frmCreditCheckDetails.get("usage1").value + this.frmCreditCheckDetails.get("usage2").value) * this.frmCreditCheckDetails.get('rate').value
    };

    this.creditCheckService.performCreditCheckLight(request).subscribe(res => {
      this.creditCheckResponse = res;
      this.store.dispatch(new SetCreditCheckStatus(0, this.creditCheckResponse.status));
      this.store.dispatch(new SetCreditCheckErrorMessage(0, this.creditCheckResponse.errorMessage));
      this.isCreditCheckInProgress = false;
    })
  }

  public canPerformCreditCheck(): boolean {
    return this.frmCreditCheckDetails?.get("usage1").value && this.frmCreditCheckDetails?.get("usage2").value && this.frmCreditCheckDetails?.get("rate").value;
  }

  close() {
    this.dialogRef.close();
  }

  redo() {
    this.initializeForm();
    this.creditCheckResponse = null;
  }

  initializeForm() {
    this.frmCreditCheckDetails = new FormGroup({
      usage1: new FormControl(null, [Validators.required, Validators.min(1)]),
      usage2: new FormControl(null, [Validators.required, Validators.min(1)]),
      rate: new FormControl(this.supplierConfig.riskDefaultRateValue, [Validators.required, Validators.min(0.01)])
    });
  }
  get statusLabel(): CreditCheckStatusLabel {
    return getStatusLabel(this.creditCheckResponse?.status);
  }
}
